import { all, put, call, takeEvery } from 'redux-saga/effects'
import getMenuData from '../../services/menu'
import actions from './actions'

import { hasPermission, hasModuleAccess } from 'helpers/license/licenseUtils';


export function* GET_DATA(action) {
  // console.log('Menu saga GET_DATA called with action:', action);
  
  const userPermissions = action?.payload?.userPermissions || [];
  const authContext = action?.payload?.authContext || null;
  // const privileges = authContext?.user?.extra?.privileges || { permissions: [], module_access: [] };
  // console.log('Menu saga - userPermissions:');
  // console.log('Menu saga - userPermissions:', userPermissions);
  // console.log('Menu saga - authContext:', authContext);
  // Example usage of non-hook helpers if needed:
  // const canViewCalendar = hasPermission('calendar.view', privileges);
  // const canAccessSales = hasModuleAccess('sales', privileges);
  
  // Set loading state
  yield put({
    type: 'menu/SET_STATE',
    payload: {
      loading: true,
      error: null,
    },
  })

  try {
    // console.log('Calling getMenuData with userPermissions');
    // console.log('Calling getMenuData with userPermissions:', userPermissions, 'and authContext:', authContext);
    const menuData = yield call(getMenuData, userPermissions, authContext)
    // console.log('getMenuData returned:', menuData);
    // console.log('getMenuData type:', typeof menuData);
    // console.log('getMenuData length:', Array.isArray(menuData) ? menuData.length : 'not an array');
    
    yield put({
      type: 'menu/SET_STATE',
      payload: {
        menuData,
        loading: false,
        error: null,
      },
    })
    // console.log('Menu state updated successfully');
  } catch (error) {
    console.error('Menu loading error:', error);
    yield put({
      type: 'menu/SET_STATE',
      payload: {
        menuData: [],
        loading: false,
        error: error.message || 'Failed to load menu data',
      },
    })
  }
}

export default function* rootSaga() {

  yield all([
    takeEvery(actions.GET_DATA, GET_DATA),
    // Remove the initial call since we need permissions from AuthContext
    // GET_DATA(), // run once on app load to fetch menu data
  ])
}
